export const buses = [
  {
    id: 1,
    name: "13 & 17 Seater Ford Traveller",
    image: "/images/gallery/bus/ford-traveller.png",

    gallery: [
      "/images/gallery/bus/ford-traveller.png",
      "/images/gallery/bus/ford-traveller-interior.jpg",
      "/images/gallery/bus/ford-traveller-tyre.jpg"
    ],

    body: "Tempo Traveller",
    seats: "13 / 17",
    doors: "4",
    engine: "Diesel",
    transmission: "Manual",
    fuel: "Diesel",
    ac: "AC / Non-AC"
  },

  {
    id: 2,
    name: "13 Seater SML",
    image: "/images/gallery/bus/sml-13.png",

    gallery: [
      "/images/gallery/bus/sml-13.png",
      "/images/gallery/bus/sml-13-interior.jpg",
      "/images/gallery/bus/sml-13-tyre.jpg"
    ],

    body: "Mini Bus",
    seats: "13",
    doors: "2",
    engine: "Diesel",
    transmission: "Manual",
    fuel: "Diesel",
    ac: "AC / Non-AC"
  },

  {
    id: 3,
    name: "32 Seater Push Back (AC)",
    image: "/images/gallery/bus/pushback-32-ac.png",

    gallery: [
      "/images/gallery/bus/pushback-32-ac.png",
      "/images/gallery/bus/pushback-32-ac-interior.jpg",
      "/images/gallery/bus/pushback-32-ac-tyre.jpg"
    ],

    body: "Tourist Bus",
    seats: "32",
    doors: "2",
    engine: "Diesel",
    transmission: "Manual",
    fuel: "Diesel",
    ac: "AC"
  },

  // {
  //   id: 4,
  //   name: "35 Seater High Back (Non-AC)",
  //   image: "/images/gallery/bus/highback-35.png",

  //   // gallery: [
  //   //   "/images/gallery/bus/highback-35.jpg",
  //   //   "/images/gallery/bus/highback-35-interior.jpg"
  //   // ],

  //   body: "Tourist Bus",
  //   seats: "35",
  //   doors: "2",
  //   engine: "Diesel",
  //   transmission: "Manual",
  //   fuel: "Diesel",
  //   ac: "Non-AC"
  // },

  

  {
    id: 6,
    name: "10 & 17 Seater Urbania",
    image: "/images/gallery/bus/urbania.png",

    gallery: [
      "/images/gallery/bus/urbania.png",
      "/images/gallery/bus/urbania-interior.jpg",
      "/images/gallery/bus/urbania-tyre.jpg"
    ],

    body: "Urbania Traveller",
    seats: "10 / 17",
    doors: "4",
    engine: "Diesel",
    transmission: "Manual / Automatic",
    fuel: "Diesel",
    ac: "AC / Non-AC"
  }
];
